<template>
  <div class="complaint-channel">
    <div class="card">
      <div class="card-icon card-icon-phone">
        <span class="iconfont icon-tonghua"></span>
      </div>
      <div class="card-title">投诉服务热线</div>
      <div class="card-desc">点击电话即可复制</div>
      <div class="info-box" @click="copyText(hotline)">
        <div class="info-main">{{ hotline }}</div>
        <div class="info-sub">(周一到周日9:00-21:00)</div>
      </div>
    </div>

    <div class="card">
      <div class="card-icon card-icon-email">
        <svg viewBox="0 0 48 48" aria-hidden="true">
          <rect x="8" y="12" width="32" height="24" rx="3" fill="#fff" />
          <path d="M8 15l16 12 16-12" fill="none" stroke="#4a90e2" stroke-width="2.5" />
        </svg>
      </div>
      <div class="card-title">投诉服务Email</div>
      <div class="card-desc">点击邮箱即可复制</div>
      <div class="info-box" @click="copyText(email)">
        <div class="info-main">{{ email }}</div>
      </div>
    </div>

    <div class="footer-tip">感谢您对我们服务的监督，这将使我们做得更好~</div>
  </div>
</template>

<script>
export default {
  name: "ComplaintChannel",
  data() {
    return {
      hotline: "157-5913-3813",
      email: "zushoping@163.com"
    };
  },
  methods: {
    copyText(text) {
      const that = this;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            that.$dialog.success("复制成功");
          })
          .catch(() => {
            that.fallbackCopy(text);
          });
        return;
      }
      that.fallbackCopy(text);
    },
    fallbackCopy(text) {
      const input = document.createElement("textarea");
      input.value = text;
      input.setAttribute("readonly", "readonly");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        this.$dialog.success("复制成功");
      } catch (e) {
        this.$dialog.error("复制失败，请手动复制");
      }
      document.body.removeChild(input);
    }
  }
};
</script>

<style scoped>
.complaint-channel {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 0.24rem 0.2rem 0.6rem;
  box-sizing: border-box;
}

.card {
  background-color: #fff;
  border-radius: 0.16rem;
  padding: 0.48rem 0.3rem 0.4rem;
  margin-bottom: 0.24rem;
  text-align: center;
}

.card-icon {
  width: 0.96rem;
  height: 0.96rem;
  margin: 0 auto 0.28rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  flex-shrink: 0;
}

.card-icon .iconfont {
  font-size: 0.5rem;
  color: #fff;
  line-height: 1;
}

.card-icon svg {
  width: 0.52rem;
  height: 0.52rem;
  display: block;
}

.card-icon-phone {
  background: linear-gradient(135deg, #ffb347 0%, #ff8c1a 100%);
}

.card-icon-email {
  background: linear-gradient(135deg, #6eb5ff 0%, #4a90e2 100%);
  border-radius: 0.2rem;
}

.card-title {
  font-size: 0.34rem;
  color: #282828;
  font-weight: 600;
  line-height: 1.4;
}

.card-desc {
  margin-top: 0.12rem;
  font-size: 0.24rem;
  color: #999;
  line-height: 1.4;
}

.info-box {
  margin-top: 0.28rem;
  padding: 0.28rem 0.24rem;
  border: 1px solid #e8e8e8;
  border-radius: 0.12rem;
  background-color: #fff;
}

.info-main {
  font-size: 0.34rem;
  color: #282828;
  line-height: 1.5;
  word-break: break-all;
}

.info-sub {
  margin-top: 0.08rem;
  font-size: 0.22rem;
  color: #999;
  line-height: 1.4;
}

.footer-tip {
  margin-top: 0.36rem;
  padding: 0 0.2rem;
  text-align: center;
  font-size: 0.24rem;
  color: #999;
  line-height: 1.6;
}
</style>
